module.exports = require("./ta.js");